import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';

interface DisclosurePopupTitleProps {
  title: React.ReactNode;
  handleClose: () => void;
}

export function DisclosurePopupTitle({ title, handleClose }: DisclosurePopupTitleProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
      <Box sx={{ p: 0 }}>{title}</Box>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          color: 'neutral.darkest',
          fontSize: {
            md: '1rem',
          },
          position: {
            sm: 'absolute',
          },
          right: {
            xs: '-35%',
            sm: '.5rem',
          },
          top: '50%',
          transform: {
            xs: 'translateY(-50%)',
          },
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
}
